import { IUserStatusType } from "@backend/model/role";
import { ISetting, SettingType } from "@backend/model/setting";

export const isSettingEnabled = (settings: ISetting[], type: SettingType) => {
  const setting = settings.find((s) => s.type === type);
  if (setting) return !!setting.value;

  return false;
};

export const isIncludedSettingEnabled = (
  settings: ISetting[],
  type: SettingType
) => {
  const setting = settings.find((s) =>
    s.type.toLowerCase().includes(type.toLowerCase())
  );
  if (setting) return !!setting.value;

  return false;
};

export const filterSettings = (
  workStatus: IUserStatusType,
  settings: ISetting[]
) => {
  let filteredSettings = [];
  if (workStatus == "visitor") {
    filteredSettings = settings.filter((a) => a.type.includes("visitor"));
  } else if (workStatus == "contractor") {
    filteredSettings = settings.filter((a) => a.type.includes("contractor"));
  } else if (workStatus == "employee") {
    filteredSettings = settings.filter(
      (a) => !a.type.includes("visitor") && !a.type.includes("contractor")
    );
  } else {
    filteredSettings = settings.filter(
      (a) => !a.type.includes("visitor") && !a.type.includes("contractor")
    );
  }
  return filteredSettings;
};

export const getSettingList = (settings: ISetting[]) => {
  return settings
    .filter(obj => obj.value === true) // Keep only the "true" objects
    .map(obj => obj.type);             // Extract the "type" property
};